var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-assemblytype"},[_c('b-form-radio-group',{attrs:{"name":`${_vm.tPath}.Radiogroup`,"options":_vm.types},model:{value:(_vm.activeType),callback:function ($$v) {_vm.activeType=$$v},expression:"activeType"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }